import React from 'react';
import { Image } from 'react-bootstrap';
import PlayButton from './PlayButton';

const IntroStassifySliderItem = ({ slideData, onPlay }: { slideData: any; onPlay: () => void }) => (
	<div className="slide-item position-relative">
		<Image
			src={slideData.videoThumbnail}
			className="w-100 h-100 object-fit-cover"
			alt={slideData.title}
			loading="lazy"
		/>
		<div className="img-overlay position-absolute top-0 start-0 w-100 h-100"></div>
		<div className="slide-item-content d-flex align-items-center position-absolute w-100 bottom-0 gap-3">
			<div className="flex-1">
				<h4 className="text-white fw-bold">{slideData.title}</h4>
				{slideData.banner_video_duration > 0 && (
					<p className="text-white mb-0 d-flex align-items-center gap-1 gap-md-2">
						<i className="ri-time-fill" aria-hidden="true"></i>
						{slideData.duration}
					</p>
				)}
			</div>
			<div>
				<PlayButton onClick={onPlay} ariaLabel={`Play ${slideData.title}`} />
			</div>
		</div>
	</div>
);
export default IntroStassifySliderItem;
